import React from "react";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  colors,
  Divider,
  Button,
  Modal,
  Typography,
} from "@material-ui/core";
import { Invite } from "./components/users/types";

const useModalStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    outline: "none",
    boxShadow: theme.shadows[20],
    width: 500,
    maxHeight: "100%",
    overflowY: "auto",
    maxWidth: "100%",
  },
  actions: {
    justifyContent: "flex-end",
  },
  deactivateButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.red[600],
    "&:hover": {
      backgroundColor: colors.red[900],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: colors.red[600],
      },
    },
  },
  closeIconAction: {
    "&:hover": {
      cursor: "pointer",
    },
    margin: 0,
  },
  bold: {
    fontWeight: 550,
  },
}));

export type DeleteInviteModalProps = {
  open: boolean;
  invite: Invite | null;
  onClose: () => void;
  onDelete: () => void;
};

function DeleteInviteModal({
  open,
  invite,
  onClose,
  onDelete,
}: DeleteInviteModalProps) {
  const classes = useModalStyles();
  const userString = invite ? invite.to_email : "this user";

  return (
    <Modal onClose={onClose} open={open}>
      <Card className={clsx(classes.root)}>
        <CardHeader
          title="Delete Teammate Invite"
          classes={{ action: clsx(classes.closeIconAction) }}
          action={<CloseIcon onClick={onClose} />}
        />
        <Divider />
        <CardContent>
          <Typography variant="body1">
            <span className={clsx(classes.bold)}>
              Are you sure you want to delete the invitation for {userString}{" "}
              from your account?
            </span>
          </Typography>
        </CardContent>
        <Divider />
        <CardActions className={classes.actions}>
          <Button onClick={onClose}>Close</Button>
          <Button
            className={classes.deactivateButton}
            onClick={onDelete}
            variant="contained"
          >
            Delete User Invite
          </Button>
        </CardActions>
      </Card>
    </Modal>
  );
}

export default DeleteInviteModal;
